/*
 * Gives you play/pause buttons to control when automated negotiation actions are applied
 *
 * Expects params: { party: (json obj) }
 */
import React from 'react';
import {confirmWithCheck} from './confirm_with_check.js.jsx'
export default class AutomatedNegotiationActionControls extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      party: {}
    };
  }

  componentDidMount() {
    this.setState({ party: this.props.party });
    this.setState({ checked: this.props.party.play_automated_actions});
    this.props.onPlay(this.props.party.play_automated_actions);

    setInterval(this.reloadParty, 30000);
  }

  reloadParty = () => {
    $.ajax({
      url: '/api/v1/parties/' + this.props.party.id,
      dataType: 'json',
      type: "GET",
      success: function(data) {
        this.setState({ party: data.party });
      }.bind(this)
    });
  }

  saveParty = () => {
    var scope = this;

    var post_data = {
      id: this.props.party.id,
      play_automated_actions: this.state.party.play_automated_actions
    };

		$.ajax({
      url: '/api/v1/parties/' + this.props.party.id,
      dataType: 'json',
      type: "PUT",
      data: {party: post_data},
      success: function(data) {
        this.setState({ party: data.party });
        this.setState({ checked: data.party.play_automated_actions});
        this.props.onPlay(data.party.play_automated_actions);
        /*
        $.notify({
          icon: 'fa fa-check',
          title: 'Success',
          message: ''
        },{ type: "success", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 1051 });
        */
      }.bind(this),
      error: function(xhr, status, err) {

        $.notify({
          icon: 'fa fa-times',
          title: '',
          message: xhr.responseJSON || 'Failed to perfom action'
        },{ type: "danger", delay: 8000, placement: { from: "bottom", align: "left" }, z_index: 1051 });
      }.bind(this)
    });
  }

  playMoves = () => {
    const isConfirmed = confirmWithCheck(I18n.components.automated_negotiation_action_controls.confirm_submit_title, {
            confirmLabel: I18n.components.automated_negotiation_action_controls.ok,
            abortLabel: I18n.components.automated_negotiation_action_controls.cancel,
            agreement: I18n.components.automated_negotiation_action_controls.i_confirm_and_submit,
    }).then(
      (value) => {
        this.state.party.play_automated_actions = true;
        this.setState({ party: this.state.party });
        this.saveParty();
      },
      (reason) => {

      },
    );
  }

  stopMoves = () => {
    this.state.party.play_automated_actions = false;
    this.setState({ party: this.state.party });
    this.saveParty();
  }
  togglePlay = () => {
    if (this.props.parent_toggle == true){
      console.log("playing is true");
      this.stopMoves();
    } else {
      console.log("playing is false");
      this.playMoves();
    }
    //this.setState({ checked: !this.state.checked });
    console.log("togglePlay");
  }

  render() {

    var playStyle = classNames({
      'btn': true,
      'btn-success': this.state.party.play_automated_actions,
      'btn-default': !this.state.party.play_automated_actions
    });

    var stopStyle = classNames({
      'btn': true,
      'btn-warning': !this.state.party.play_automated_actions,
      'btn-default': this.state.party.play_automated_actions
    });

    var action_status = this.state.party.automated_moves_state_message;

    return (
      <div>
        <div className="col-sm-2 pull-right">
          { this.props.parent_toggle ? <i onClick={this.togglePlay} className="fa fa-pause-circle" style={{fontSize: "40px"}}></i> : <i onClick={this.togglePlay} className="fa fa-play-circle" style={{fontSize: "40px"}}></i> } 
        </div>
        <div className="col-sm-6 pull-right" style={{padding: '5px 0px', textAlign: 'right', color: "black"}}>
          <span onClick={this.togglePlay}>{(this.props.parent_toggle == true)? I18n.components.automated_negotiation.press_to_pause : I18n.components.automated_negotiation.press_to_submit}  <i className="fa fa-arrow-right"></i></span>
        </div>
      </div>
    );
  }
}
